import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { WidgetSize } from '@wix/wix-chatbot-common/browser';

// Matched by type string on purpose: importing chatActions would drag the chat slice's module graph in here.
const CHAT_RESET_ACTION = 'chat/reset';

type WidgetState = Readonly<{
  size: WidgetSize;
  expanded: boolean;
  mobileView?: boolean; // means widget container(iframe) stretched to full screen size(works based on `only screen and (max-width: 760px)`)
  caraActiveInOtherTab: boolean;
  caraFullPageSessionActive: boolean;
  caraSessionInConversation: boolean;
  caraSurveyPending: boolean;
}>;

const initialState: WidgetState = {
  size: WidgetSize.Default,
  expanded: true,
  caraActiveInOtherTab: false,
  caraFullPageSessionActive: false,
  caraSessionInConversation: false,
  caraSurveyPending: false,
};

export const widgetSlice = createSlice({
  name: 'widget',
  initialState,
  reducers: {
    setSize: (state, action: PayloadAction<WidgetSize>) => {
      state.size = action.payload;
    },
    setExpanded: (state, action: PayloadAction<boolean>) => {
      state.expanded = action.payload;
    },
    setMobileView: (state, action: PayloadAction<boolean>) => {
      state.mobileView = action.payload;
    },
    setCaraActiveInOtherTab: (state, action: PayloadAction<boolean>) => {
      state.caraActiveInOtherTab = action.payload;
    },
    setCaraFullPageSessionActive: (state, action: PayloadAction<boolean>) => {
      state.caraFullPageSessionActive = action.payload;
    },
    setCaraSessionInConversation: (state, action: PayloadAction<boolean>) => {
      state.caraSessionInConversation = action.payload;
    },
    setCaraSurveyPending: (state, action: PayloadAction<boolean>) => {
      state.caraSurveyPending = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(CHAT_RESET_ACTION, (state) => {
      state.caraSessionInConversation = false;
      state.caraSurveyPending = false;
    });
  },
});

export const widgetActions = widgetSlice.actions;
